import React from 'react';
import './Tooltip.scss';
import { motion } from 'framer-motion';
import { ReactComponent as TooltipTip } from '../../../../../assets/tooltipTip.svg';

const tooltipVariants = {
  hidden: {
    opacity: 0,
    top: '36px',
    transition: {
      delay: 0.1,
      duration: 0.2,
      type: 'spring',
      ease: 'easeInOut',
    },
  },
  visible: {
    opacity: 1,
    top: '31px',
    transition: {
      delay: 0.1,
      duration: 0.2,
      type: 'spring',
      ease: 'easeInOut',
    },
  },
};

const Tooltip = ({ children, direction }) => {
  return (
    <motion.div
      key={children}
      variants={tooltipVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      className="tooltip text_greyishBrown font_regular"
      style={direction === 'left' ? { left: '16px' } : { right: '16px' }}
    >
      <TooltipTip
        style={
          direction === 'left'
            ? {
                top: '-3.8px',
                left: '-11px',
                transform: `rotate(11deg) translateZ(-10px)`,
              }
            : {
                top: '-3.8px',
                right: '-10px',
                transform: `rotate(179deg) translateZ(-10px) scale(1, -1)`,
              }
        }
      />
      {children}
    </motion.div>
  );
};

export default Tooltip;
